import { AlertType } from '../enums/enums';
import { Step } from './step.model';
import { QuoteRequest } from './itinerary.model';
import { ExchangeQuoteRequest } from './voluntary-change.model';

export interface Endpoint {
  parameter: Parameter;
}

export interface Parameter {
  appId: string;
  url: string;
}

export interface AirportParameter {
  parameter: {
    iataCode: string;
    city: string;
    name: string;
    timeZone: string;
  };
}

export interface IAirportByName {
  id: string;
  isActive: boolean;
  type: string;
  parameter: {
    name: string;
    iataCode: string;
    city: string;
    timeZone: string;
    countryIsoCode: string;
  };
  userIDCreate: string;
  userIDUpdate: string | null;
  operationId: string | null;
  agencyId: string | null;
}

export interface Airline {
  id?: string;
  isActive?: true;
  type: string;
  parameter?: AirlineParameter;
  userIDCreate?: string;
  userIDUpdate?: string;
  operationId?: string;
}

export interface AirlineParameter {
  name?: string;
  iataCode?: string;
  ticketNumberPrefix?: string;
}

export interface User {
  id: string;
  firstName?: string;
  lastName?: string;
  name: string;
  email: string;
  agencyId: string;
  operationId: string;
  roles: string[];
  claims?: Claim[];
  userName?: string;
}

export interface CurrencyParameter {
  parameter: Currency;
}

export interface Currency {
  isoCode: string;
  description?: string;
  country: { name: string; isoCode: string; iva: number };
}

export interface Claim {
  type: string;
  value: string;
}

// Error
export interface ContractError {
  message: string;
  controllerName: string;
  actionName: string;
  stackTrace: string;
  errorCode: number;
  alertType?: AlertType;
  canBeRetried?: boolean;
}

// Error
export interface SpinnerMessages {
  messages: string[];
  maxTime: number;
}

export interface BreadcrumbRoute {
  name: string;
  route: string;
  isActive: boolean;
  queryParams?: any;
}

export interface IAlertMessage {
  message: string;
  isAccepted: boolean;
  translate?: boolean;
}

export interface SelectInput {
  name: string;
  code: string | number;
}

export interface MiniState {
  state: AlertType;
  data?: any;
  error?: ContractError;
  loading?: boolean;
  request?: any | QuoteRequest | ExchangeQuoteRequest;
}

export interface StepMiniState {
  steps: Step[];
  activeStep: number;
}

export interface ChangePasswordRequest {
  userId: string;
  oldPassword?: string;
  newPassword: string;
  userLoggedId: string;
}

export enum AppLanguages {
  english = 'en',
  spanish = 'es-CO',
  spanishMexican = 'es-MX',
  portuguese = 'pt'
}

export interface IFarebasisSegment {
  hasFarebasisCodes: boolean;
  farebasisCodes: string[];
}
